module.exports = __webpack_public_path__ + "static/media/group_creation.7ed5ae03.png";